export class CommonListElementSettings {
    allowDrop = false;
    isVisible = true;
    draggable = false;
    highlighted = false;
}